import { useEffect, useState } from 'react'
import { Container, Row, Col, Spinner, Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { useUser } from '../contexts/userContext'
import { isString } from '../utils'
import ProgressNavBar from './ProgressNavBar'

export const Slide = ({
  name,
  leftContent,
  leftColSize,
  rightContent,
  rightColSize,
  leftColSizeLg,
  rightColSizeLg,
  noBack,
  nextTo,
  backTo,
  step,
  totalSteps,
  stageName,
  footerText,
  onNextClick,
  nextButtonText,
  showNextButton = true,
  showNextButtonInContent = false,
  showProgress = true,
  showWallet = true,
  className,
  rightContentClasses = '',
  ...props
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const { user, setUser } = useUser()
  const onboardingStage = window.location.pathname
  const isNextDisabled = nextTo === null
  const navigate = useNavigate()
  // const goBack = () => (backTo ? navigate(backTo) : navigate(-1))
  const goBack = () => navigate(-1)
  const goNext = isString(nextTo) ? () => navigate(nextTo) : nextTo
  const doNextNav = async () => {
    if (isNextDisabled) return
    if (onNextClick) {
      setIsLoading(true)
      await onNextClick()
      setIsLoading(false)
    }
    goNext()
  }

  useEffect(() => {
    // Save onboarding progress on load/navigation
    if (onboardingStage !== '/' || user?.onboardingStage !== onboardingStage) {
      setUser(currUser => ({ ...currUser, onboardingStage }))
    }
    // Cleanup callback
    return () => {}
  }, [])

  const nextButtonIcon = isLoading ? (
    <Spinner animation='border' variant='light' />
  ) : (
    <i className='bi bi-arrow-right-short' data-attr='next'></i>
  )

  const nextButtonTexContent = isLoading ? (
    <span>
      <Spinner
        as='span'
        size='sm'
        role='status'
        aria-hidden='true'
        animation='border'
        variant='light'
        className='me-2'
      />
      Submitting...
    </span>
  ) : (
    nextButtonText
  )

  const nextButton = (
    <Button
      variant='primary'
      className={nextButtonText ? 'next-text-button' : 'next-button'}
      onClick={doNextNav}
      disabled={isLoading ? true : isNextDisabled}
    >
      {nextButtonText ? nextButtonTexContent : nextButtonIcon}
    </Button>
  )

  const progressNavBar = classes => (
    <ProgressNavBar
      className={classes}
      goBack={goBack}
      noBack={noBack}
      step={step}
      totalSteps={totalSteps}
      stageName={stageName}
      showProgress={showProgress}
      showWallet={showWallet}
    />
  )

  return (
    <Container fluid={true} className={`frame ${name} ${className}`} {...props}>
      <Row>
        <Col
          className='left'
          xs={leftColSize}
          lg={leftColSizeLg || leftColSize}
          style={{
            backgroundImage: `url(/imgs/aragon-background.png)`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}
        >
          {progressNavBar('left-header')}
          {leftContent}
        </Col>

        <Col
          className='right'
          xs={rightColSize}
          lg={rightColSizeLg || rightColSize}
          style={footerText ? { position: 'relative' } : {}}
        >
          {progressNavBar('right-header')}
          <div className={`right-content ${rightContentClasses}`}>
            {rightContent}
            {showNextButtonInContent && showNextButton && nextButton}
          </div>
          <div className='footer' style={footerText ? {} : { left: 'unset' }}>
            {footerText && (
              <div
                className='footer-text underline me-3'
                dangerouslySetInnerHTML={{ __html: footerText }}
              ></div>
            )}
            {showNextButton && !showNextButtonInContent && nextButton}
          </div>
        </Col>
      </Row>
    </Container>
  )
}
export default Slide
